export const color = {
	typeface: {
		heading: "#F0F1EC",
		subheading: "#8f918d",
		paragraph: "#aaaca7",
		title: "#F0F1EC",
		body: "#f0f1ec",
		caption: "#aaaca7",
		overline: "#aaaca7",
		link: "#03ff8f",
		primary: "#03ff8f",
	},
	surface: {
		default: "#141414",
	},

}
